<template>
  <Modal class="support-call" @close="close" :hideFooter="true">
    <template #header>
      <h3>Need help? We’re here for you</h3>
    </template>
    <template #body>
      <div
        class="tw-bg-highlight-background-weak tw-px-6 tw-py-4 tw-flex tw-flex-col tw-justify-center tw-items-center tw-gap-4 tw-rounded-lg"
      >
        <font-awesome-icon icon="fa-solid fa-user-headset" class="tw-text-icon tw-text-[16px]" />
        <div class="tw-text-center">
          Get the fastest and most detailed support by filing a case. Our experts will review your
          issue and provide a comprehensive solution.
        </div>
        <Btn variant="primary" testId="tickets-open-ticket-btn" @click="addTicket"> Open Case </Btn>
      </div>
      <div class="tw-py-4 tw-flex tw-justify-center tw-items-center tw-gap-4 mt-4 tw-mb-6">
        <img :src="require('@/assets/support-person.png')" />
        <div>
          <span class="tw-font-bold">Prefer to chat?</span> Experts are online now to answer any
          questions you may have
        </div>
        <Btn
          class="tw-whitespace-nowrap tw-border tw-border-border-strong tw-py-3"
          variant="transparent"
          :loading="chatLoading"
          @click="startChart"
        >
          <font-awesome-icon
            v-if="!chatLoading"
            icon="fa-solid fa-circle"
            class="tw-text-success-icon-strong tw-text-[12px] tw-mr-1"
          />
          <span class="tw-leading-[12px]">Start Chat</span>
        </Btn>
      </div>
      <div class="tw--mx-9 tw-px-9 tw-py-4 tw-border-t tw-border-border">
        <div class="tw-flex tw-justify-between tw-items-center">
          Looking for phone support?
          <font-awesome-icon
            class="tw-text-icon tw-cursor-pointer tw-text-[16px]"
            :icon="angleIcon"
            @click="togglePhoneSupport"
          />
        </div>
        <div
          v-if="showPhoneSupport"
          class="tw-flex tw-justify-between tw-items-center tw-mt-4 tw-gap-2"
        >
          <div class="tw-flex">
            <a :href="`tel:${US}`" class="tw-inline-flex tw-items-center tw-gap-2 tw-no-underline">
              <Logo logo="location-us" :size="24" />
              <div class="tw-font-medium tw-text-xs">{{ US }}</div>
            </a>
          </div>
          <div class="tw-h-4 tw-w-px tw-bg-border" />
          <div class="tw-flex">
            <a :href="`tel:${UK}`" class="tw-inline-flex tw-items-center tw-gap-2 tw-no-underline">
              <Logo logo="location-uk" :size="24" />
              <div class="tw-font-medium tw-text-xs">{{ UK }}</div>
            </a>
          </div>
          <div class="tw-h-4 tw-w-px tw-bg-border" />
          <div class="tw-flex">
            <a :href="`tel:${AU}`" class="tw-inline-flex tw-items-center tw-gap-2 tw-no-underline">
              <Logo logo="location-au" :size="24" />
              <div class="tw-font-medium tw-text-xs">{{ AU }}</div>
            </a>
          </div>
        </div>
      </div>
    </template>
  </Modal>
</template>

<script>
import { computed, ref } from "vue";
import Btn from "@/components/display/Btn";
import constants from "@/utils/constants";
import ContactSupport from "@/components/smart/modals/ContactSupport";
import Logo from "@/components/display/Logo";
import Modal from "@/components/display/Modal";
import { openChat } from "@/utils/chat";
import router from "@/router";
import store from "@/store";

export default {
  name: "SupportCallModal",
  components: {
    Btn,
    Logo,
    Modal,
  },
  emits: ["close"],
  setup(props, { emit }) {
    const close = () => emit("close");
    const chatLoading = ref(false);
    const showPhoneSupport = ref(false);
    const { US, UK, AU } = constants.SUPPORT.PHONE;

    const addTicket = () => {
      store.dispatch("modals/open", {
        template: ContactSupport,
      });
    };

    const startChart = () => {
      const matchedRoutes = [...router.currentRoute.value.matched];
      const isCheckout = matchedRoutes.reverse().find((route) => !!route.meta.isCheckout);
      const extraDetails = {
        preselectDepartment:
          isCheckout && store.getters["surveys/requireSurvey"]
            ? store.getters["surveys/getSurveyType"]
            : null,
      };

      chatLoading.value = true;

      openChat(extraDetails).finally(() => {
        // close suppport call modal when chat window is spawned
        store.dispatch("modals/closeById", "support-call-modal");
        chatLoading.value = false;
      });
    };

    const togglePhoneSupport = () => (showPhoneSupport.value = !showPhoneSupport.value);

    const angleIcon = computed(() =>
      showPhoneSupport.value ? "fa-light fa-angle-up" : "fa-light fa-angle-down"
    );

    return {
      close,
      chatLoading,
      addTicket,
      startChart,
      togglePhoneSupport,
      showPhoneSupport,
      angleIcon,
      US,
      UK,
      AU,
    };
  },
};
</script>
<style lang="scss">
@import "~@/styles/variables";

.call-icon {
  padding: 16px;
  cursor: pointer;

  svg {
    display: block;
    margin: auto;
  }
}

.call-border {
  border: solid 1px;
  border-radius: 5px;
}

.support-call {
  .modal-content {
    .modal-container {
      padding-bottom: 0;
    }
  }
}
</style>
